var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2024186e41d09f2e23249704edc8718af112de3b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["walle-client@classapp-31"]={id:"2024186e41d09f2e23249704edc8718af112de3b"};
      